import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Estimation from "@/pages/Estimation";
import ThankYou from "@/pages/ThankYou";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import GamePage from "@/pages/Game";
import MapPage from "@/pages/PriceMap";
import Blog from "@/pages/Blog";
import Article from "@/pages/Article";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import LegalNotice from "@/pages/LegalNotice";
import { CookieBanner } from "@/components/CookieBanner";
import { Loader2 } from "lucide-react";

function ProtectedRoute({ children }) {
  const { user, checking } = useAuth();
  if (checking)
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="w-8 h-8 animate-spin text-[#2563EB]" />
      </div>
    );
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <CookieBanner />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/estimation" element={<Estimation />} />
            <Route path="/merci" element={<ThankYou />} />
            <Route path="/jeu" element={<GamePage />} />
            <Route path="/carte" element={<MapPage />} />
            <Route path="/actualites" element={<Blog />} />
            <Route path="/actualites/:slug" element={<Article />} />
            <Route path="/confidentialite" element={<PrivacyPolicy />} />
            <Route path="/mentions-legales" element={<LegalNotice />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
